import { render } from "./ReviewTaskListWidget.vue?vue&type=template&id=20f838f2&ts=true"
import script from "./ReviewTaskListWidget.ts?vue&type=script&lang=ts&external"
export * from "./ReviewTaskListWidget.ts?vue&type=script&lang=ts&external"

import "./ReviewTaskListWidget.vue?vue&type=style&index=0&id=20f838f2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__